export default __webpack_public_path__ + "static/media/my-enrollments-black.b4937611.svg";